import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { MovieModel, Comment } from 'src/app/core/interfaces/movie.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-movie-comment-item',
  templateUrl: './movie-comment-item.component.html',
  styleUrls: ['./movie-comment-item.component.scss']
})
export class MovieCommentItemComponent implements OnInit {

  @Input() comment: Comment;
  @Output() onClicked = new EventEmitter<any>();


  commentMovie: MovieModel;
  commentDateFormated: string;
  movieLink: string;
  authorProfileLink: string;

  starsFull: any;
  starsHalf: any;
  starsEmpty: any;

  showMoreText: boolean = false;
  maxCommentLenght: number = 125;

  isCriticReview: boolean = false;

  constructor(public san: DomSanitizer) { }

  ngOnInit(): void {
    this.prepararDatos();
    this.calculateStars();

  }

  prepararDatos() {

    this.isCriticReview = this.comment.author.isCritic;

    this.commentMovie = this.comment.movieModel;

    let commentDate = this.comment.createdTime.toString();
    this.commentDateFormated = moment(commentDate).format("YYYY-MM-DD");

    this.movieLink = "/movie/" + this.commentMovie.id;

    this.authorProfileLink = "/perfil/" + this.comment.userId;

  }

  get picture() {
    return environment.apiEndpoint + this.commentMovie.pictures.find(p => p.isDefault).pictureLink;
  }

  calculateStars() {
    let originScore = this.comment.score;
    let full;
    let half;
    let empty;
    if (originScore % 1 == 0) { //Si tiene un score entero
      full = originScore;
      half = 0;
      empty = 5 - originScore; //5 porque el maximo de estrellas es 5
    }
    else { //Si tiene un score decimal
      full = Math.floor(originScore)
      half = 1;
      empty = 4 - full; //4 porque el maximo es 5 y siempre va a haber una media estrella
    }
    //estos son array vacios solo para el ngFor.
    this.starsFull = new Array(full);
    this.starsHalf = new Array(half);
    this.starsEmpty = new Array(empty);

  }

  onClick() {
    this.onClicked.next();
  }

}
